var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4",attrs:{"id":"list-silo-equipment-component"}},[_c('in-progress-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }